import { motion } from "framer-motion";
import { Price } from "@/components/z6/Price";
import { hexToRgba } from "@/lib/menuTheme";

export const ACCENT = "#0F8A96";

export const Orb = ({ thinking, size = "md", className = "" }) => (
  <div aria-hidden data-testid={thinking ? "hara-orb-thinking" : "hara-orb"} className={`hara-orb ${size === "sm" ? "hara-orb-sm" : size === "lg" ? "hara-orb-lg" : ""} ${thinking ? "hara-orb-thinking" : ""} ${className}`}>
    <span className="hara-orb-core" />
    <span className="hara-orb-ring" />
    <span className="hara-orb-ring hara-orb-ring-2" />
    <span className="hara-orb-ring hara-orb-ring-3" />
    <span className="hara-orb-dash" />
  </div>
);

export const Bubble = ({ children, from = "hara", testId, delay = 0 }) => (
  <motion.div data-testid={testId} initial={{ opacity: 0, y: 16, scale: 0.97 }} animate={{ opacity: 1, y: 0, scale: 1 }}
    transition={{ type: "spring", stiffness: 160, damping: 20, delay }}
    className={`flex ${from === "hara" ? "justify-start" : "justify-end"}`}>
    <div className={`font-ui max-w-[min(560px,88%)] rounded-[22px] px-5 py-3.5 text-[15px] leading-relaxed ${from === "hara" ? "hara-bubble rounded-tl-md text-[#0B2E44]" : "rounded-tr-md bg-white/80 text-[#0B2E44] ring-1 ring-[#0B2E44]/15"}`}>
      {children}
    </div>
  </motion.div>
);

export const Chip = ({ active, onClick, children, testId, color = ACCENT, disabled }) => (
  <motion.button type="button" layout whileTap={{ scale: 0.9 }} transition={{ type: "spring", stiffness: 500, damping: 26 }}
    data-testid={testId} onClick={onClick} disabled={disabled} aria-pressed={!!active}
    className="z6-btn z6-btn--sm">
    {children}
  </motion.button>
);

export const PrimaryBtn = ({ children, onClick, disabled, testId, className = "" }) => (
  <motion.button whileTap={{ scale: 0.96 }} type="button" data-testid={testId} onClick={onClick} disabled={disabled}
    className={`z6-btn z6-btn--pink min-h-[52px] ${className}`}>
    {children}<span aria-hidden className="z6-arrow" />
  </motion.button>
);

const LINE_LABEL = { starter: "Small plate", main: "Large plate", dessert: "Dessert", broth: "Broth" };

export const PriceBreakdown = ({ pricing, testId = "plate-pricing" }) => (
  <div data-testid={testId} className="font-ui space-y-1.5 text-[15px] text-[#0B2E44]">
    {pricing.lines.map((l) => (
      <div key={l.course} className="flex justify-between gap-3" data-testid={`${testId}-line-${l.course}`}>
        <span className="min-w-0 truncate"><span className="mr-2 font-mono text-[15px] uppercase tracking-[0.2em] text-[#0B2E44]">{LINE_LABEL[l.course]}</span>{l.name}{l.serve ? ` (${l.serve[0]}${l.serve.slice(1).toLowerCase()})` : ""}</span>
        <span className="shrink-0 text-right"><Price value={l.price} size="row" /></span>
      </div>
    ))}
    <div className="flex justify-between border-t border-[#0B2E44]/15 pt-2 text-[15px] text-[#0B2E44]"><span>Total</span><span data-testid={`${testId}-total`}><Price value={pricing.total} size="total" /></span></div>
  </div>
);
